import { Header } from "./Header";
import { Footer } from "./Footer";
import { useSite } from "@/hooks/useSite";

export const Layout = ({ children }) => {
  const { data } = useSite();
  const settings = data?.settings;
  return (
    <div className="min-h-screen flex flex-col bg-[var(--pp-bg)]">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-white p-2 z-[60]">Skip to content</a>
      <Header links={settings?.links} />
      <main id="main" className="flex-1">{children}</main>
      <Footer settings={settings} />
    </div>
  );
};
